module.exports = __webpack_public_path__ + "img/173.amount_of_the_food.3caca0ab.svg";